import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import * as L from 'leaflet';

/**
 * Stops mouse/touch/scroll events on the host element from reaching the
 * underlying Leaflet map, so interacting with an in-map overlay (e.g. the
 * AISstream playback toolbar) does not pan/zoom the map underneath.
 */
@Directive({ selector: '[appLeafletStopPropagation]' })
export class LeafletStopPropagationDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const node = this.el.nativeElement;
    L.DomEvent.disableClickPropagation(node);
    L.DomEvent.disableScrollPropagation(node);
  }
}
